// extracted by mini-css-extract-plugin
export default {"revenueContainer":"styles_revenueContainer__VLTi-","secondRow":"styles_secondRow__IfSl6","loading":"styles_loading__kYf6M"};